import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceResearch {
    lookupService = new APIServiceLookUp();

    async getAllResearch(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}research/getAllResearch`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getResearchById(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}research/getResearchById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateResearchPage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}research/updateResearchPage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateResearch(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}research/updateResearch`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setResearch(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}research/setResearch`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delResearch(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}research/delResearch`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateResearch(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}research/updateResearch`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}